import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { ITypeProperty, ITypePropertyById } from '../models/type-property'

export interface ITypePropertyLookup {
  _id: string
  id: string
  name: string
  code: string
  /** Id (ObjectId) del proyecto al que pertenece — la proyección del lookup lo incluye. */
  project: string
}

/**
 * Lookups legacy (selectors dependientes, editor de plantillas, impresión).
 * El CRUD admin vive en type-properties-admin.service.ts (listado paginado +
 * mutaciones zod).
 */
export const typePropertiesService = {
  getLookup: () =>
    axiosPrivate.get<ITypePropertyLookup[]>(API.typeProperties.lookup).then((r) => r.data),

  getById: (id: string) =>
    axiosPrivate.get<ITypePropertyById>(API.typeProperties.byId(id)).then((r) => r.data),

  getByProjectId: (projectId: string) =>
    axiosPrivate.get<ITypeProperty[]>(API.typeProperties.byProject(projectId)).then((r) => r.data)
}

// ── Print endpoint (document generation) ──
export const getTypePropertyByIdForPrint = (id: string) =>
  axiosPrivate.get<ITypePropertyById>(API.typeProperties.printById(id)).then((r) => r.data)

// ── Backward compatibility (used by external consumers) ──
export const getTypePropertiesLookup = typePropertiesService.getLookup
